/** Types d'exports */
enum ExportTypeEnum
{
    /// <summary>Image</summary>
    Image = "Image",
    /// <summary>Excel</summary>
    Excel = "Excel",
    /// <summary>Word portrait</summary>
    WordPortrait = "WordPortrait",
    /// <summary>Work paysage</summary>
    WordLandscape = "WordLandscape",
};

export default ExportTypeEnum;